var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7389 5.57165L4.34215 12.9684L3.3335 16.6668L7.03189 15.6582L14.4287 8.26139M11.7389 5.57165L13.42 3.89056C13.5966 3.71395 13.8063 3.57385 14.0371 3.47827C14.2678 3.38269 14.5151 3.3335 14.7649 3.3335C15.0147 3.3335 15.262 3.38269 15.4927 3.47827C15.7235 3.57385 15.9332 3.71395 16.1098 3.89056C16.2864 4.06717 16.4265 4.27684 16.5221 4.50759C16.6176 4.73834 16.6668 4.98566 16.6668 5.23543C16.6668 5.4852 16.6176 5.73252 16.5221 5.96327C16.4265 6.19402 16.2864 6.40369 16.1098 6.5803L14.4287 8.26139M11.7389 5.57165L14.4287 8.26139",
    stroke: "#9DA1AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.6ec7c084dadbd942042c007cc71cdf27.svg";
export { ForwardRef as ReactComponent };